import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getUserCondition, getUserConditionProfile, getUserWixId } from 'modules/user/utils';
import { GenericChat } from '../GenericChat/GenericChat';
import { useChat } from '../useChat';
import { CHAT_ROLES, FILE_UPLOAD_CHAT_ROOM } from '../constants';
import { countNonNullValues, extractNonNullValuesInfo, handleSendMessage } from './functions';
import './chatUploadPopup.css';

const getInitMessage = ({ manageToExtractDrugsReceived, numOfExtractedInfo }) => (
  manageToExtractDrugsReceived
    ? ` Well done! We have extracted ${numOfExtractedInfo} pieces of information from your documents. Please review them. Do you need our help to understand them? \n 
   In addition, we have extracted information about your medications. We kindly ask you to order your treatments from your diagnosis date to today. 
   \n Let me know if you need any further assistance.
   `
    : ` Well done! We have extracted  ${numOfExtractedInfo} pieces of information from your documents. Please review them. \n
    Unfortunately, we could not find any treatment information in your document. Please note that you can upload more files later on.`
);

export const ChatUploadPopup = () => {
  const { data: profile } = useSelector((state) => state.profile);

  const [init, setInit] = useState(null);
  const userWixId = getUserWixId(profile);
  const condition = getUserCondition(profile);
  const userConditionProfile = getUserConditionProfile(profile);
  const numOfExtractedInfo = countNonNullValues(userConditionProfile);
  const extractedInfo = extractNonNullValuesInfo(userConditionProfile);

  const {
    chat: { messageHistory: chatHistory } = {},
    addMessages,
  } = useChat(FILE_UPLOAD_CHAT_ROOM);

  const manageToExtractDrugsReceived =
    userConditionProfile.drugs_received &&
    Array.isArray(userConditionProfile.drugs_received) &&
    userConditionProfile.drugs_received.length > 0;

  const initMessageRef = useRef(getInitMessage({ manageToExtractDrugsReceived, numOfExtractedInfo }));

  const shouldAddInitMessage = !chatHistory?.length;

  useEffect(() => {
    if (init) {
      return;
    }

    if (shouldAddInitMessage) {
      addMessages([{ role: CHAT_ROLES.TINA, content: initMessageRef.current }]);
    }

    setInit(true);
  }, [addMessages, shouldAddInitMessage, init]);

  const handleSendMessageClick = (prompt) => handleSendMessage({
    prompt, addMessages, userWixId, condition, extractedInfo,
  });

  return init ? (
    <GenericChat
      handleSendMessageClick={handleSendMessageClick}
      chatHistory={chatHistory}
    />
  ) : null;
};
